import {Component, ContentChild, Input, OnInit, TemplateRef} from "@angular/core";

@Component({
    selector: "fui-deprecated-autocomplete-control-results",
    styleUrls: ["deprecated-autocomplete-control-results.component.scss"],
    templateUrl: "./deprecated-autocomplete-control-results.component.html"
})
export class FUIDeprecatedAutocompleteControlResultsComponent implements OnInit {
    @ContentChild("autocompletecontrolresult", {read: TemplateRef}) public autocompleteControlResult: TemplateRef<HTMLTemplateElement>;
    @Input() public increment: number;
    @Input() public limit: number;
    public position: number;
    @Input() public results: any[];
    @Input() public show: string;

    constructor() {

    }

    ngOnInit() {
        this.position = this.limit;
    }

    showMore(): void {
        this.position += this.increment;
    }

    hasShowMore(): boolean {
        return this.results && this.position < this.results.length;
    }
}
